/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import ISelectableProbe = Models.ISelectableProbe;

    export interface ITsDualListModalScope extends ng.IScope {
        allProbes: ISelectableProbe[];
        selectedProbes: ISelectableProbe[];
        
        title: string;
        titleElements: string;
        titleSelectedElements: string;
        radioButtonOptions: EurovisionControl.IRadioOption[];

        select: (probe: ISelectableProbe) => void;
        unselect: (probe: ISelectableProbe) => void;
        selectAll: () => void;
        unselectAll: () => void;

        elementsSearch: {
            node: {
                name: string;
            }
        };
        selectedElementsSearch: {
            node: {
                name: string;
            }
        };

        selectRadioButton: (networkNodeId: string) => void;
        changeDefault: () => void;
        rerenderRadioButtons: () => void;
        getConnectedNetworks: (probe: Models.NetworkNode) => Models.INetwork[];
        getConnectedNetworksTooltip: (probe: Models.NetworkNode) => string;
        getSlotsInfo: (probe: Models.TsProbe) => string;
        modalClose: () => void;
        modalSave: (selectedProbes: ISelectableProbe[]) => void;
    }

    export class TsDualListModalController {
        public static templateUrl: string = "decorators/modals/ts-probe-dual-list-modal.html";
        public static ID: string = "#id-ts-probe-dual-list-modal";
        public static $name: string = "tsDualListModalController";
        public static $inject: string[] = ['$scope', 
                                           '$timeout',
                                           'close', 
                                           'networkNodeService', 
                                           'networkNodeTypeService', 
                                           'tsProbeService', 
                                           'title', 
                                           'titleElements', 
                                           'titleSelectedElements', 
                                           'allProbes', 
                                           'selectedProbes'];

        private $scope: ITsDualListModalScope;
        private close: (selectedProbes: Models.ISelectableProbe[]) => void;

        constructor($scope: ITsDualListModalScope,
                    private $timeout: ng.ITimeoutService,
                    close: (selectedProbes: Models.ISelectableProbe[]) => void,
                    networkNodeService: Services.NetworkNodeService,
                    networkNodeTypeService: Services.NetworkNodeTypeService,
                    tsProbeService: Services.TsProbeService,
                    title: string,
                    titleElements: string,
                    titleSelectedElements: string,
                    allProbes: ISelectableProbe[],
                    selectedProbes: ISelectableProbe[]) {

            this.$scope = $scope;
            this.close = close;
            
            this.$scope.allProbes = allProbes ? allProbes
                .sort((p1: ISelectableProbe, p2: ISelectableProbe) => p1.node.name.localeCompare(p2.node.name)) : [];
            this.$scope.selectedProbes = selectedProbes ? selectedProbes : [];
            this.$scope.selectedProbes = this.$scope.selectedProbes ? this.$scope.selectedProbes
                .sort((p1: ISelectableProbe, p2: ISelectableProbe) => p1.node.name.localeCompare(p2.node.name)) : [];
            this.$scope.title = title;
            this.$scope.titleElements = titleElements;
            this.$scope.titleSelectedElements = titleSelectedElements;
            this.$scope.radioButtonOptions = [];

            this.$scope.selectedProbes.forEach((selectedProbe: ISelectableProbe) => {
                this.createNewRadioButton(this.$scope.radioButtonOptions, selectedProbe);
            });

            this.selectDefaultRadioButtonOption($scope);

            this.$scope.getConnectedNetworks = (p: Models.NetworkNode): Models.Network[] => {
                let networks: Models.Network[] = [];
                if (p && p.networkInterfaces !== undefined && p.networkInterfaces.length > 0) {
                    for (let nic of p.networkInterfaces) {
                        if (nic.connected === true) {
                            networks.push(nic.networkConnectedTo as Models.Network);
                        }
                    }
                }
                return networks;
            };

            this.$scope.getSlotsInfo = (p: Models.TsProbe): string => {
                return (p.emptySlots === 1) ? `1 slot available of ${p.totalSlots}` : `${p.emptySlots} slots available of ${p.totalSlots}`;
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (selProbes: ISelectableProbe[]): void => {
                this.changeDefaultProbe(this.$scope.radioButtonOptions, selProbes);
                this.close(selProbes);
            };

            this.$scope.select = (device: ISelectableProbe) => {
                const radioButtonIsSelected: boolean = this.$scope.selectedProbes.length === 0;
                this.createNewRadioButton(this.$scope.radioButtonOptions, device, radioButtonIsSelected);
                this.$scope.selectedProbes.push(device);
                this.$scope.allProbes = this.$scope.allProbes
                    .filter((probe: ISelectableProbe) => probe.probe.networkNodeId !== device.probe.networkNodeId);
                this.$scope.rerenderRadioButtons();
            };

            this.$scope.unselect = (device: ISelectableProbe) => {
                this.$scope.allProbes.push(device);
                this.$scope.selectedProbes = this.$scope.selectedProbes
                    .filter((probe: ISelectableProbe) => probe.probe.networkNodeId !== device.probe.networkNodeId);
                this.$scope.radioButtonOptions = this.$scope.radioButtonOptions
                    .filter((option: EurovisionControl.IRadioOption) => option.value !== device.probe.networkNodeId);
                if (this.$scope.radioButtonOptions.length === 1) {
                    this.$scope.radioButtonOptions[0].selected = true;
                }
            };

            this.$scope.selectAll = () => {
                let selectFirst: boolean = this.$scope.selectedProbes.length === 0 ? true : false;

                this.$scope.allProbes.forEach((probe: ISelectableProbe) => {
                    this.createNewRadioButton(this.$scope.radioButtonOptions, probe);
                });
                this.$scope.selectedProbes.push(...this.$scope.allProbes);
                this.$scope.allProbes = [];
                if (selectFirst) this.$scope.radioButtonOptions[0].selected = true;
                this.$scope.rerenderRadioButtons();
            };

            this.$scope.unselectAll = () => {
                this.$scope.allProbes.push(...this.$scope.selectedProbes);
                this.$scope.selectedProbes = [];
                this.$scope.radioButtonOptions = [];
            };

            this.$scope.changeDefault = () => {
                this.changeDefaultProbe(this.$scope.radioButtonOptions, this.$scope.selectedProbes);
            };

            this.$scope.rerenderRadioButtons = () => {
                const selected: EurovisionControl.IRadioOption[] = this.$scope.radioButtonOptions
                    .filter((radioButtonOption: EurovisionControl.IRadioOption) => radioButtonOption.selected);
                let selectedNode: number;
                if (selected.length === 1) {
                    selectedNode = selected[0].value;
                }
                this.$scope.radioButtonOptions = [];
                this.$scope.selectedProbes
                    .filter((probe: Models.ISelectableProbe) =>
                        !$scope.selectedElementsSearch ||
                        probe && probe.node.name.toLowerCase().indexOf($scope.selectedElementsSearch.node.name.toLowerCase()) > -1)
                    .forEach((filteredProbe: Models.ISelectableProbe) => {
                        this.createNewRadioButton(this.$scope.radioButtonOptions,
                            filteredProbe,
                            selectedNode === filteredProbe.probe.networkNodeId);
                    });
            };

        }

        public createNewRadioButton(radioButtonOptions: EurovisionControl.IRadioOption[], 
                                    device: ISelectableProbe,
                                    selected?: boolean): void {
            this.$scope.radioButtonOptions.push({
                value: device.probe.networkNodeId,
                selected: selected ? selected : device.probe.defaultProbe,
            });
        }

        public changeDefaultProbe(radioButtonOptions: EurovisionControl.IRadioOption[], selProbes: Models.ISelectableProbe[]): void {
            const defaultProbeOption: EurovisionControl.IRadioOption = this.$scope.radioButtonOptions
            .filter((option: EurovisionControl.IRadioOption) => option.selected)[0];
            if (defaultProbeOption) {
                selProbes.forEach((selectedProbe: Models.ISelectableProbe) => {
                    // tslint:disable-next-line:triple-equals
                    if (selectedProbe.probe.networkNodeId + "" == defaultProbeOption.value) {
                        selectedProbe.probe.defaultProbe = true;
                    } else {
                        selectedProbe.probe.defaultProbe = false;
                    }
                });
            }
        }

        public selectDefaultRadioButtonOption($scope: ITsDualListModalScope): void {
            this.$timeout(() => {
                const defaultProbe: ISelectableProbe = this.$scope.selectedProbes
                    .filter((probe: ISelectableProbe) => probe.probe.defaultProbe)[0];
                if (defaultProbe) {
                    this.$scope.radioButtonOptions.forEach((radioButtonOptions: EurovisionControl.IRadioOption) => {
                        // tslint:disable-next-line:triple-equals
                        if (radioButtonOptions.value == defaultProbe.probe.networkNodeId) {
                            radioButtonOptions.selected = true;
                        } else {
                            radioButtonOptions.selected = false;
                        }
                    });
                }
            });
        }
    }
}
